module.exports = __webpack_public_path__ + "static/media/Hachiko.607374df.png";